<template>
<CardTitle :title="loading ? 'Loading Customer Data...'+ customer_id : customer.primary_name.name" hide_action_spacer extended>
  <template v-if="loading" v-slot:prepend_actions>
    <v-progress-circular class="mr-3" indeterminate></v-progress-circular>
  </template>
  <template v-if="billing" v-slot:extension>
    <v-text-field v-model="sampleSearch" solo label="Search Customer's Samples" outlined dense flat></v-text-field>
    <v-list-item-content class="text-center">
      <v-list-item-subtitle>Contract</v-list-item-subtitle>
      <v-list-item-title>{{customer.contract ? customer.contract.contract_type.desc : 'none'}}</v-list-item-title>
    </v-list-item-content>
    <v-list-item-content class="text-center ml-3">
      <v-list-item-subtitle>Bill Overdue</v-list-item-subtitle>
      <v-list-item-title :class="billOverdue > 0 ? 'error white--text' : ''">${{billOverdue}}</v-list-item-title>
    </v-list-item-content>
    <v-list-item-content class="text-center">
      <v-list-item-subtitle>AR Current</v-list-item-subtitle>
      <v-list-item-title>${{billing.ar_current}}</v-list-item-title>
    </v-list-item-content>
    <v-list-item-content class="text-center">
      <v-list-item-subtitle>AR Total</v-list-item-subtitle>
      <v-list-item-title>${{billing.ar_total}}</v-list-item-title>
    </v-list-item-content>
    <v-list-item-content class="text-center">
      <v-list-item-subtitle>AR Date</v-list-item-subtitle>
      <v-list-item-title>{{billing.ar_date ? billing.ar_date : "N/A"}}</v-list-item-title>
    </v-list-item-content>
    <v-list-item-content class="text-center">
      <v-list-item-subtitle>Income Current</v-list-item-subtitle>
      <v-list-item-title>${{billing.income_current}}</v-list-item-title>
    </v-list-item-content>
    <v-list-item-content class="text-center">
      <v-list-item-subtitle>Income Date</v-list-item-subtitle>
      <v-list-item-title>{{billing.income_date ? billing.income_date : "N/A"}}</v-list-item-title>
    </v-list-item-content>
    <v-spacer></v-spacer>
  </template>
</CardTitle>
</template>

<script>
export default {
    name: "CustomerInfo",
    components: {},
    data: () => ({
      customer: null,
      loading: true,
      sampleSearch: null,
    }),
    props:{
      customer_id: {
        required: true,
      },
    },
    mounted(){
      this.loadCustomer();
    },
    watch: {
      sampleSearch(v){
        console.log('search change')
        this.$emit('search',v)
      }
    },
    computed: {
      billing(){
        if(this.customer && this.customer.billings.length > 0){
          return this.customer.billings[0]
        }
        return null;
      },
      billOverdue(){
        if(!this.billing) return '-.--';
        let current = parseFloat(this.billing.ar_current);
        let total = parseFloat(this.billing.ar_total);
        if(total > 0 && total > current){
          return (total-current);
        }
        return '0.00'
      }
    },
    methods: {
      async loadCustomer(){
        this.loading = true;
        let query = await this.$store.$db().model('customers').api().fetch({
          with: 'billings,primaryName,contract',
          where: {
            key: 'id',
            value: this.customer_id,
          }
        },"", null, false, false)
        this.customer = query.response.data[0];
        // this.customer.contract = this.customer.contracts && this.customer.contracts.length > 0 ? this.customer.contracts[0] : null;
        this.loading = false;
      },
    }
}
</script>

<style scoped>

</style>
